<template>
	<md-dialog
		:md-active="show"
		style="font-family: 'Montserrat', sans-serif"
		:style="{ zIndex: organization ? '5000' : undefined }"
	>
		<div style="width: 500px">
			<div class="dialog-header">
				<span style="margin-top: auto; margin-bottom: auto; font-size: 18px">{{ $t("add-new-user") }}</span>
				<div style="margin-left: auto; margin-right: 0">
					<md-button @click="() => $emit('close')" class="md-icon-button" style="margin-right: -5px">
						<md-icon style="color: white">close</md-icon>
					</md-button>
				</div>
			</div>
			<div class="dialog-body">
				<div class="container" v-if="organization == undefined && isSuperAdmin">
					<span>{{ $t("school") }}</span>
					<el-select
						v-model="org"
						:placeholder="$t('school')"
						style="width: 100%"
						filterable
						clearable
						remote
						reserve-keyword
						:remote-method="fetch"
					>
						<el-option
							v-for="item in organizations"
							:key="item.id"
							:value="item"
							:label="item.name.String"
						/>
					</el-select>
				</div>
				<div class="container">
					<span>{{ $t("username") }}</span>
					<el-input
						v-model="user.username"
						:placeholder="$t('username')"
						:class="{ 'md-elevation-4': focus == 'username' }"
						@focusin="focus = 'username'"
						@focusout="focus = undefined"
					/>
				</div>
				<div class="container">
					<span>{{ $t("email") }}</span>
					<el-input
						v-model="user.email"
						:placeholder="$t('email')"
						:class="{ 'md-elevation-4': focus == 'email' }"
						@focusin="focus = 'email'"
						@focusout="focus = undefined"
					/>
				</div>
			</div>
			<p>{{ $t("") }}</p>
			<div class="dialog-footer" style="width: 100%">
				<div style="margin-left: auto; margin-right: 0">
					<md-button class="cancel" @click="() => $emit('close')">{{ $t("cancel") }}</md-button>
					<md-button class="add" @click="add">
						<i class="el-icon-loading" v-if="loading" />
						<span>{{ $t("add") }}</span>
					</md-button>
				</div>
			</div>
		</div>
	</md-dialog>
</template>

<script>
import axios from "axios"
import { mapActions, mapGetters } from "vuex"
export default {
	name: "add-user",
	props: ["show", "organization"],
	data() {
		return {
			loading: false,
			user: {
				email: "",
				username: ""
			},
			focus: undefined,
			organizations: [],
			org: undefined
		}
	},
	computed: {
		...mapGetters({
			roles: "organization/roles",
			maximum: "organization/maximum",
			isSuperAdmin: "user/isSuperAdmin"
		})
	},
	created() {
		if (this.roles.length == 0) {
			this.doRoles()
		}
	},
	methods: {
		...mapActions({
			doAdd: "user/doAdd",
			doRoles: "organization/doRoles"
		}),
		async add() {
			var org_id = 0
			if (this.org && this.organization == undefined) org_id = this.org.id
			else if (this.organization) org_id = this.organization.id
			else org_id = undefined
			var payload = {
				...this.user,
				roles: [this.roles[0].id],
				language: localStorage.getItem("lang"),
				organization_id: org_id
			}

			var obj = await this.doAdd(payload)
			if (obj.user) {
				this.$notification(
					"success",
					this.$t("added-new-user-successful"),
					this.$t("confirmation-mail-sent-to-user"),
					4500
				)

				this.$emit("add", obj.user)
			} else {
				this.$processError(this.$t("add-new-user-error"), obj.err.Message)
			}
		},
		fetch: function(query) {
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/organizations/search",
					{ query },
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					this.organizations = res.data
				})
				.catch(err => {
					console.error(err)
				})
		}
	}
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/my-dialog";

.container {
	display: flex;
	margin: 7px 0px;
	span {
		width: 200px;
		margin-top: auto;
		margin-bottom: auto;
		padding: 7px;
	}
}

.el-select {
	color: red;
}
</style>
